import { BaseComponent } from '../BaseComponent';
import { ComponentNames } from 'src/app/helper/componentNames';

export class SeatWithStorageComponent extends BaseComponent {
    constructor() {
        super();
        this.componentType = ComponentNames.seatWithStorageComponent;
    }
    groundSupport: boolean;
    tableForOwnSeat: boolean;
    socket: boolean;
    // w1 is the width value for one of the seats
    // this property maps to basedimensions.length in the following way
    // l = (w1 * 2) + s1;
    w1:number; 
    w2:number;
    w3:number;
    w4:number;
    // h1 isn't necessary here since it's represented by basedimension.height
    h2:number;
    h3:number;
    s1:number;
}